import React, { useState } from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import './ReportCardPage.css'


const DocumentRepositoryPageUI = ({ context, errorList, loan, categoryList, onRefreshClick,
  uploadCategory, onUploadClick, onCancelUpload, onUpload, onDownloadClick,
  onDownloadSectionClick, onDownloadLoanClick, onDeleteClick, downloadingKey
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_repc' backLink='/su/documentRepository'
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !categoryList}
    account={loan && loan.account}
    page='documentRepository'
  >
    {
      (!loan || !categoryList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && categoryList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Document Repository</b></span>
            </span>
          }
          right={
            <span className='g_link' onClick={onDownloadLoanClick}>
              Download All
            </span>
          }
        />

        {
          categoryList
            .map((cat, i) =>
              <DocumentCategoryCardUI key={i} category={cat}
                onUploadClick={() => onUploadClick(cat.category)}
                onDownloadClick={onDownloadClick}
                onDownloadSectionClick={() => onDownloadSectionClick(cat.category)}
                onDeleteClick={onDeleteClick}
                downloadingKey={downloadingKey}
              />
            )
        }
      </div>
    }
    <FileUploadModalSF context={context}
      titleLabel={uploadCategory === 'underwriting' ? 'Upload Credit Memo' : 'Upload Document'}
      uploadMode={!!uploadCategory}
      onCancelClick={onCancelUpload}
      signedUrlApi={
        loan && uploadCategory &&
        (uploadCategory === 'underwriting'
          ? `/api/su/loans/${loan.loanId}/documentRepository/creditMemo/signedUploadUrl`
          : `/api/su/loans/${loan.loanId}/documentRepository/${uploadCategory}/signedUploadUrl`)
      }
      onUpload={onUpload}
    />
  </SuperUserAccountPageUI>

const DocumentCategoryCardUI = ({ category, onUploadClick, onDownloadClick, onDownloadSectionClick, onDeleteClick, downloadingKey }) => {
  const [expanded, setExpanded] = useState(false)
  const sectionBusy = downloadingKey === `section:${category.category}`
  return (
    <CardUI className='g_m_top_20'>
      <div className='g_flex_h g_flex_left g_cursor_pointer' onClick={() => setExpanded(!expanded)}>
        <span className={`icon ${expanded ? 'icon-chevron-down' : 'icon-chevron-right'} g_m_right_100`}></span>
        <span className='g_large'><b>{category.displayName}</b></span>
        <span className='g_muted g_m_left_100'>({category.fileList.length})</span>
        <span className='g_link g_m_left_100' onClick={(e) => { e.stopPropagation(); onUploadClick() }}>
          Upload
        </span>
        <span className={sectionBusy ? 'g_muted g_m_left_100' : 'g_link g_m_left_100'}
          onClick={(e) => { e.stopPropagation(); if (!sectionBusy) onDownloadSectionClick() }}>
          {sectionBusy ? 'Downloading...' : 'Download Section'}
        </span>
      </div>

      {
        expanded && category.fileList.length === 0 &&
        <div className='g_muted g_m_top_100'>No documents</div>
      }

      {
        expanded && category.fileList.length > 0 &&
        <table className='g_full_width g_m_top_20'>
          <thead>
            <tr>
              <th className='g_p_right_100'>Document</th>
              <th className='g_p_left_100'>File</th>
              <th className='g_p_left_100'></th>
            </tr>
          </thead>
          <tbody>
            {
              category.fileList.map((file, j) =>
                <tr key={j}>
                  <td className='g_p_right_100'>{file.label || file.fileName}</td>
                  <td className='g_p_left_100'>
                    <span className={downloadingKey ? 'g_muted' : 'g_link'}
                      onClick={() => { if (!downloadingKey) onDownloadClick(category.category, file) }}>
                      {file.label || file.fileName}
                    </span>
                  </td>
                  <td className='g_p_left_100'>
                    {
                      file.manuallyUploaded &&
                      <span className='icon icon-trash-o g_cursor_pointer g_muted'
                        onClick={() => onDeleteClick(category.category, file)}
                      />
                    }
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      }
    </CardUI>
  )
}

export default DocumentRepositoryPageUI

